"use strict";

// export class AppConfiguration {
//     private static instance: AppConfiguration;
//     private _json: any;
//     private constructor() { }
//     static Setting() {
//         if (!AppConfiguration.instance) {
//             AppConfiguration.instance = new AppConfiguration();
//             AppConfiguration.instance._json = require('../../../appsettings.json');
//         }
//         return AppConfiguration.instance._json;
//     }
// }
Object.defineProperty(exports, "__esModule", {
  value: true
});
class AppConfiguration {
  constructor() {}
  static Setting() {
    return this.json;
  }
}
AppConfiguration.json = require('../../../appsettings.json');
exports.AppConfiguration = AppConfiguration;